import axios from 'axios'
import { Filter } from '../../interfaces'
import { ApiConfig } from '../../config/api'
import { PreSaleSkuUpdate } from './entities/PreSaleSku'
import { templateUpdateStockPreSaleSku } from '../../const/templatesFileName'

export const getPreSaleSku = (
  filters?: Filter[],
  page = 0,
  pageSize = 5,
  orderBy?: { field: string; direction: string }
) => {
  const url = new URL(`${ApiConfig.PreSaleSkuApi}`)

  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      url.searchParams.append(element.key, element.value.toString())
    })
  }

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}

export const updatePreSaleSku = (id: number, dto: PreSaleSkuUpdate) => {
  const url = new URL(`${ApiConfig.PreSaleSkuApi}/${id}`)
  return axios.put(url.toString(), dto)
}

export const postExportPreSaleSkuMasive = (filters?: Filter[]) => {
  const url = new URL(`${ApiConfig.ProcessApi}/ExportPreSaleSkuMasive`)
  const jsonObject = filters?.reduce((acc, filter) => {
    acc[filter.key] = filter.value
    return acc
  }, {} as Record<string, any>)
  return axios.post(url.toString(), jsonObject)
}

export const postUpdatePreSaleSkuMasiveFile = (dto: FormData) => {
  const url = new URL(`${ApiConfig.ProcessApi}/UpdatePreSaleSkuMasiveFile`)

  const headers = {
    'Content-Type': 'multipart/form-data'
  }

  return axios.post(url.toString(), dto, { headers })
}

export const getUpdatePreSaleSkuTemplate = () => {
  const url = new URL(
    `${ApiConfig.ProcessApi}/GetTemplateFile/${templateUpdateStockPreSaleSku}`
  )
  return axios.get(url.toString())
}
